import React, { ChangeEvent } from 'react';
import { Box, TextField, RadioGroup, FormControlLabel, Radio, Typography, MenuItem, Switch } from '@mui/material';
import { ISetupPdfMessages } from '../../../../../../types/setupPDFTypes';
import { ITocStyles, ETocSeparator, ITocFontType, TOC_FONT_TYPES, TOC_NODE_ID } from '@opengov/stories-shared/constants';

import { styles } from './TableOfContents.styles';

export const TableOfContents = ({
  messages,
  tocStyles,
  onTocStylesChange,
  toggledStoriesVisibilityMap,
  onToggledStoriesVisibilityMapChange
}: {
  messages: ISetupPdfMessages;
  tocStyles: ITocStyles;
  onTocStylesChange: (value: ITocStyles) => void;
  toggledStoriesVisibilityMap: { [nodeId: string]: boolean };
  onToggledStoriesVisibilityMapChange: (value: { [nodeId: string]: boolean }) => void;
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const updatedTocStyles = { ...tocStyles, separator: event.target.value as ETocSeparator };
    onTocStylesChange(updatedTocStyles);
  };

  const handleFontTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const updatedTocStyles = { ...tocStyles, fontType: event.target.value as ITocFontType };
    onTocStylesChange(updatedTocStyles);
  };

  return (
    <Box sx={styles.container}>

      <FormControlLabel
        sx={styles.switchControlLabel}
        control={<Switch size="small" inputProps={styles.controls} />}
        label={
          <span
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
              }
            }}
            role="button"
            tabIndex={0}
          >
            {messages.showTableOfContents}
          </span>
        }
        labelPlacement="start"
        checked={toggledStoriesVisibilityMap[TOC_NODE_ID] === true}
        onChange={(_, checked) => {
          if (!checked) {
            onToggledStoriesVisibilityMapChange({ ...toggledStoriesVisibilityMap, [TOC_NODE_ID]: false });
          } else {
            onToggledStoriesVisibilityMapChange({ ...toggledStoriesVisibilityMap, [TOC_NODE_ID]: true });
          }
        }}
      />
      {toggledStoriesVisibilityMap[TOC_NODE_ID] === true && <> <Typography sx={styles.tocTitle}>{messages.titleAndPageSeparator}</Typography>
        <RadioGroup
          aria-labelledby="toc-separator-radio-buttons-group-label"
          name="toc-separator-radio-buttons-group"
          value={tocStyles.separator}
          onChange={handleChange}
        >
          <FormControlLabel
            value={ETocSeparator.Whitespace}
            control={<Radio inputProps={styles.radioButton} />}
            label={messages.whitespace}
          />
          <FormControlLabel
            value={ETocSeparator.Dotted}
            control={<Radio inputProps={styles.radioButton} />}
            label={messages.dotted}
          />
        </RadioGroup>

        <Typography sx={styles.tocTitle}>{messages.fontType}</Typography>
        <TextField
          id="select-font-type"
          select
          value={tocStyles.fontType}
          onChange={handleFontTypeChange}
          variant="outlined"
          sx={styles.textField}
        >
          {TOC_FONT_TYPES.map((option) => (
            <MenuItem selected={tocStyles.fontType === option.value} key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </>
      }
    </Box>
  );
};
